export class PublisherModel {
  UpdateAPI: string = "";
  PublisherByIDAPI: string = "";
  StageListAPI: string = "";
  PlatFormListAPI: string = "";
  PageLayoutListAPI: string = "";
  JournalTypeListAPI: string = "";
  RefStyleListAPI: string = "";
  BillingTypeListAPI: string = "";
  CountryListAPI: string = "";
  StateListAPI: string = "";
  CityListAPI: string = "";
  publisherListAPI: any;
  EmailFormatErrorMsg: any;
  JournalTypeAPI: any;
  CE_PreEditListAPI: any;
  ProjectFromListAPI: any;
  ShowPublisherNotesByID: string;
  PublisherNotesByIDAPI: any;
  DeletePublisherNotesByID: string;
  PublisherNotesDownloadFilesAPI: string;
  GetArticleStageAPI: any;

}
